import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  padding: 32px 24px 24px;
  border-radius: 16px;
  background-color: ${rgba(WHITE, 0.1)};
  display: flex;

  .question {
    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      height: 48px;
      width: 48px;
      border-radius: 50%;
      background-color: ${rgba(WHITE, 0.2)};
      margin-right: 28px;
    }

    &__question {
      line-height: 3rem;
    }
  }

  ${breakpoints.down('xs')} {
    padding: 16px 16px 28px;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .question {
      &__icon {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
  }
`;

export default Container;
